/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The redirect URI a newly created remote_session_client registers.
 */
export type NewClientCallbackURLResult = {
  /**
   * The redirect URI to register on the upstream provider's OAuth app.
   */
  callbackUrl: string;
};

/** @internal */
export const NewClientCallbackURLResult$inboundSchema: z.ZodMiniType<
  NewClientCallbackURLResult,
  unknown
> = z.pipe(
  z.object({
    callback_url: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "callback_url": "callbackUrl",
    });
  }),
);

export function newClientCallbackURLResultFromJSON(
  jsonString: string,
): SafeParseResult<NewClientCallbackURLResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => NewClientCallbackURLResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'NewClientCallbackURLResult' from JSON`,
  );
}
